import { GeckoAssemblyJSON } from './geckoAssembly'
import { GeckoAssemblyConfigurationJSON } from './geckoAssemblyConfiguration'
import { GeckoEquipmentJSON } from './geckoEquipment'
import { GeckoEquipmentConfigurationJSON } from './geckoEquipmentConfiguration'
import { GeckoSubAssemblyJSON } from './geckoSubAssembly'
import { GeckoWorkOrderJSON } from './geckoWorkOrder'

export type InfoCardMode = 'view' | 'edit' | 'create'

export enum InventoryEntryType {
  Assembly = 'assembly',
  SubAssembly = 'sub-assembly',
  Equipment = 'equipment',
  EquipmentConfiguration = 'equipment-configuration',
  AssemblyConfiguration = 'assembly-configuration',
  WorkOrder = 'work-order',
}

export type BaseInventoryEntry<T> = {
  id: string
  type: InventoryEntryType
  data: T
  generation?: number | null | undefined
  index?: { [key: string]: unknown } | null
  tags?: { [key: string]: string | null }
  created_at?: string
  updated_at?: string
  last_updated_by?: string
}

export type InventoryEntryWrapper<T> = {
  entry: BaseInventoryEntry<T>
  assignedParent?: string
}

// Discriminated union types that associate specific type values with their data types
export type AssemblyEntry = InventoryEntryWrapper<GeckoAssemblyJSON> & {
  entry: BaseInventoryEntry<GeckoAssemblyJSON> & {
    type: InventoryEntryType.Assembly
  }
}

export type SubAssemblyEntry = InventoryEntryWrapper<GeckoSubAssemblyJSON> & {
  entry: BaseInventoryEntry<GeckoSubAssemblyJSON> & {
    type: InventoryEntryType.SubAssembly
  }
}

export type EquipmentEntry = InventoryEntryWrapper<GeckoEquipmentJSON> & {
  entry: BaseInventoryEntry<GeckoEquipmentJSON> & {
    type: InventoryEntryType.Equipment
  }
}

export type EquipmentConfigurationEntry =
  InventoryEntryWrapper<GeckoEquipmentConfigurationJSON> & {
    entry: BaseInventoryEntry<GeckoEquipmentConfigurationJSON> & {
      type: InventoryEntryType.EquipmentConfiguration
    }
  }

export type AssemblyConfigurationEntry =
  InventoryEntryWrapper<GeckoAssemblyConfigurationJSON> & {
    entry: BaseInventoryEntry<GeckoAssemblyConfigurationJSON> & {
      type: InventoryEntryType.AssemblyConfiguration
    }
  }

export type WorkOrderEntry = InventoryEntryWrapper<GeckoWorkOrderJSON> & {
  entry: BaseInventoryEntry<GeckoWorkOrderJSON> & {
    type: InventoryEntryType.WorkOrder
  }
}

// Union type for all inventory entries
export type InventoryEntry =
  | AssemblyEntry
  | SubAssemblyEntry
  | EquipmentEntry
  | EquipmentConfigurationEntry
  | AssemblyConfigurationEntry
  | WorkOrderEntry

export enum AssignmentType {
  BulkEquipment = 'bulk-equipment',
  Equipment = 'equipment',
  BulkAssembly = 'bulk-assembly',
  Assembly = 'assembly',
  WorkOrderAssembly = 'work-order-assembly',
  WorkOrderEquipment = 'work-order-equipment',
}

export type AssignmentJSONType = AssemblyEntry | SubAssemblyEntry

export type ConfigEntryJSONType =
  | EquipmentConfigurationEntry
  | AssemblyConfigurationEntry

export type ParentInventoryItems = 'equipment' | 'assembly'

export type InspectionEntry = {
  id: string
  tags?: { [key: string]: string | null }
}
